export default "__VITE_ASSET__c0ef7dbd__"